import { render, staticRenderFns } from "./EventsLeaderBoard.vue?vue&type=template&id=0860d90a&scoped=true&lang=html&"
import script from "./EventsLeaderBoard.vue?vue&type=script&lang=js&"
export * from "./EventsLeaderBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0860d90a",
  null
  
)

export default component.exports